import { ERROR_DETAILS } from '@/constants/error-details';

const state = {
	showModal: false,
	errorDetails: {},
};

const mutations = {
	SHOW_ERROR_MODAL(state, payload) {
		state.showModal = true;
		state.errorDetails = payload.errorDetails;
	},
	CLOSE_ERROR_MODAL(state) {
		state.showModal = false;
		state.errorDetails = {};
	},
};

const actions = {
	showErrorModal({ commit }, { errorDetails = {} }) {
		commit('SHOW_ERROR_MODAL', { errorDetails });
	},
	showApiErrorModal(
		{ commit },
		{
			path = '/',
			message = '',
			buttonLabel = 'Return to Dashboard',
			buttonAction = 'routerPush',
		},
	) {
		const errorDetails = {
			...ERROR_DETAILS.API_ERROR,
			error: 'Unable to retrive data',
			message:
				`${message} Please try again in a few minutes. If this error persists please reach out to your Account Executive.`.trim(),
			buttonLabel,
			buttonAction,
			path,
		};
		commit('SHOW_ERROR_MODAL', { errorDetails });
	},
	closeErrorModal({ commit }) {
		commit('CLOSE_ERROR_MODAL');
	},
};

export default {
	state,
	mutations,
	actions,
};
